import CapacityManager from 'actions/routing/capacity_manager';

export default function (context) {
  const capacityManager = new CapacityManager(context);
  return capacityManager;
}
